const COMIC = { textile: 'bold colourful comic book illustration with thick black outlines and flat colours', engraving: 'bold comic book illustration with thick clean outlines and simple hatching' };
const LINES = 'clean line art drawing with confident outlines, no shading';

// Context chips while the assistant is open: [id, label, action]. Quick tool actions run directly, the rest asks the assistant.
export function suggestionsFor(editor, { send, quick, processing, again, lastId, toggleRefine, showQuality, showFinish }) {
  const one = editor.selectedObjects.length === 1 ? editor.selected : null, textile = !!editor.textile;
  const check = ['check', textile ? 'Prüfen, ob alles gut druckt' : 'Prüfen, ob alles gut graviert', showQuality], finish = ['finish', 'Fertig? Zusammenfassen', showFinish];
  if (one?.type === 'text') return [
    ['font', 'Andere Schrift', () => send('Schlag eine passendere Schrift für den ausgewählten Text vor und setz sie ein.')],
    one.curve ? ['arc', 'Gerade', () => editor.patchObject(one.id, { curve: 0 })] : ['arc', 'Im Bogen', () => editor.patchObject(one.id, { curve: 120 })],
    ['ideas', 'Spruch-Ideen', () => send('Gib mir Spruch-Ideen passend zu meinem Design.')],
  ];
  if (one?.type === 'image' && one.aiGenerated) return [
    ...(lastId === one.id ? [['refine', 'Dieses Bild verändern …', toggleRefine], ['again', 'Neu würfeln', again]] : []),
    ['text', 'Text dazu', () => send('Setz einen passenden Text zum ausgewählten KI-Bild.')],
    ['smaller', 'Kleiner', () => editor.patchObject(one.id, { scale: (one.scale || 1) * .85 })],
    ['bigger', 'Größer', () => editor.patchObject(one.id, { scale: (one.scale || 1) * 1.15 })],
  ];
  if (one?.type === 'image' && one.assetId && !one.stockKind) return [
    ['comic', 'In Comic umwandeln', () => quick({ photo_transform: { asset: one.assetId, label: 'Comic-Figur', prompt: COMIC[textile ? 'textile' : 'engraving'] } })],
    ['lines', 'Als Strichzeichnung', () => textile ? quick({ photo_transform: { asset: one.assetId, label: 'Strichzeichnung', prompt: LINES } }) : processing.applyEffect(one.id, 'lines', 50)],
    ['cutout', 'Hintergrund entfernen', () => processing.removeBackground(one.id)],
    ['below', 'Text darunter', () => send('Setz einen passenden Text unter das ausgewählte Bild.')],
  ];
  const base = [
    ['motif', 'Motiv für mich finden', () => send('Hilf mir, ein passendes Motiv zu finden.')],
    ['logo', 'Logo erstellen', () => send('Ich möchte ein Logo erstellen.')],
    ['photo', 'Foto gestalten', () => send('Ich möchte mit einem Foto gestalten.')],
    ['quote', 'Spruch vorschlagen', () => send('Schlag mir einen passenden Spruch vor.')],
  ];
  return editor.objects.length >= 1 ? [finish, check, ...base.filter(([id]) => id !== 'photo')] : base;
}

export const selectedLabel = editor => {
  const o = editor.selectedObjects.length === 1 ? editor.selected : null;
  if (!o) return null;
  if (o.type === 'text') return `Text „${String(o.text || '').slice(0, 40)}“`;
  if (o.type === 'image') return o.aiGenerated ? `KI-Bild „${o.name || ''}“ (id ${o.id})` : `Foto/Bild „${o.name || ''}“ (id ${o.id})`;
  return o.name || o.type;
};
